<span
  mat-button
  mat-dialog-close
  class="unlock-close-btn"
  aria-label="Close dialog"
>
  <i id="closeOverlay" class="far fa-times-circle"></i>
</span>

<h1 mat-dialog-title class="unlock-title">Receiver Signature</h1>
<hr class="divider">

<div
  mat-dialog-content
  class="unlock-content"
  role="dialog"
  aria-modal="true"
  aria-labelledby="unlock-title"
>
  <div class="signature-header">
    <p class="unlock-subtitle">Receiver signature confirmation</p>
    
    <div class="signature-display">
      <div class="signature-image-container">
        <img 
          [src]="delivery?.receiverSign || 'assets/img/no-image.jpg'" 
          class="signature-image"
        >
      </div>
      
      <div class="signature-details">
        <div class="detail-row">
          <span class="detail-label">Receiver:</span>
          <span class="detail-value">{{ fullName  }}</span>
        </div>
        <!-- <div class="detail-row">
          <span class="detail-label">Signed:</span>
          <span class="detail-value">{{ delivery?.signatureDate | date:'short' }}</span>
        </div> -->
      </div>
    </div>
  </div>
</div>

<div mat-dialog-actions class="unlock-actions">
  <button mat-button mat-dialog-close class="btn-secondary">Close</button>
</div>
